// react core
import React, { useEffect } from 'react';
import SubHeaderContainer from 'components/sub_header/container';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
// tagetik ui componetns
import ScrollToTop from 'components/commons/scroll_top';
import QASearcher from 'components/sub_header/qa_searcher';
import MyQaActivity from 'components/colums/my_activity';
// confs
import conf from 'conf/ajax';

// show filter only on main page
function TopBar(props)
{
    let location = useLocation();

    if (location.pathname.split('?')[0] === conf.route.main || location.pathname.split('?')[0] === `${conf.route.main}/`)
    {
        return <SubHeaderContainer {...props} />
    }
    else
    {
        return <></>
    }
}

export default function SiteRoot(props)
{
    const history = useLocation();
    const navigate = useNavigate();

    // using to redirect from base_dir to /base_dir/questions
    useEffect(() =>
    {
        // redirect /base_dir with or without slash to main route
        if(
            (history.pathname.split('?')[0] === conf.route.base) ||
            (history.pathname.split('?')[0] === conf.route.base_without_slash)
        )
        {
            // redirect...
            navigate(conf.route.main);
        }
    }, [history, navigate]);

    // then I initialize the components with properties
    return (
        <>
            <ScrollToTop />
            <QASearcher />
            <div className="row" id="row-content">
                <div className="col-md-9 margin-40 pull-right">
                    <TopBar />
                    <Outlet />
                </div>
                <div className="col-md-3 margin-80 pull-left" id="sidenav">
                    <MyQaActivity />
                </div>
            </div>
        </>
    );
};